import { Unit, UNIT_TRANSLATED } from '@enmon/commons';
import { Form, Space, UploadFile } from 'antd';
import { FormItem } from 'components/Form/FormItem';
import { ImageUpload } from 'components/ImageUpload/ImageUpload';
import { Select } from 'components/Select/Select';
import { Fragment, VFC } from 'react';
import { RegisterState } from 'routes/meter_replacement/useStore';
import { FormattedMessage, useIntl } from 'react-intl';
import { InputNumber } from 'components/Input/InputNumber';
import type { ServiceInspectionFormValues } from './Content';
import { ServiceInspection as messages } from '../messages';

interface RegistersProps {
  onPhotoSelect: (fieldName: number, fileList: UploadFile[]) => void;
}

export const Registers: VFC<RegistersProps> = ({ onPhotoSelect }) => {
  const form = Form.useFormInstance<ServiceInspectionFormValues>();
  const selectedRegisterStates = Form.useWatch(['registerStates'], { form });
  const intl = useIntl();

  return (
    <Form.List name="registerStates">
      {fields =>
        fields.map((field, index) => {
          const { fullObis } = selectedRegisterStates?.[field.name] ?? {};
          return (
            <Fragment key={field.key}>
              <Space>
                <span>
                  {intl.formatMessage(messages.register)} {index + 1}:
                </span>
                <strong>
                  {selectedRegisterStates?.[field.name].name ?? '-'} ({fullObis ?? '-'})
                </strong>
              </Space>
              <FormItem
                required
                label={<FormattedMessage {...messages.registerStatus} />}
                name={[field.name, 'counter']}
                rules={[{ required: true, message: intl.formatMessage(messages.registerRequired) }]}
              >
                <InputNumber
                  addonAfter={
                    <FormItem noStyle name={[field.name, 'unit']}>
                      <Select
                        options={[Unit.kWh, Unit.MWh, Unit.m3, Unit.GJ, Unit.MJ].map(unitOption => ({
                          value: unitOption,
                          label: UNIT_TRANSLATED[unitOption],
                        }))}
                        style={{ minWidth: 100 }}
                      />
                    </FormItem>
                  }
                  className="w-100"
                  placeholder="473.8"
                />
              </FormItem>
              <FormItem
                required
                label={<FormattedMessage {...messages.registerPhotos} />}
                name={[field.name, 'photos' satisfies keyof RegisterState]}
                rules={[{ required: true, message: intl.formatMessage(messages.registerRequired) }]}
              >
                <ImageUpload
                  multiple
                  fileList={selectedRegisterStates?.[field.name]?.photos ?? []}
                  name="photos"
                  onImageUpload={fileList => onPhotoSelect(field.name, fileList)}
                />
              </FormItem>
            </Fragment>
          );
        })
      }
    </Form.List>
  );
};
